import apiClient from './axiosConfig';
import { API_ENDPOINTS } from '../constants';

const workEducationApi = {
  getWorkEducation: async ({ page = 1, perPage = 10, search = '', includeTrashed = false } = {}) => {
    try {
      const response = await apiClient.get(`${API_ENDPOINTS.WORK_EDUCATION}`, {
        params: { page, per_page: perPage, search, trashed: includeTrashed ? 'true' : 'false' },
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching work and education entries:', error);
      throw error;
    }
  },

  getWorkEducationByIdentifier: async (identifier) => {
    try {
      const response = await apiClient.get(`${API_ENDPOINTS.WORK_EDUCATION}/${identifier}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching work and education entry ${identifier}:`, error);
      throw error;
    }
  },

  createWorkEducation: async (workEducationData) => {
    try {
      const response = await apiClient.post(`${API_ENDPOINTS.WORK_EDUCATION}`, workEducationData);
      return response.data;
    } catch (error) {
      console.error('Error creating work and education entry:', error);
      throw error;
    }
  },

  updateWorkEducation: async (identifier, workEducationData) => {
    try {
      const response = await apiClient.put(`${API_ENDPOINTS.WORK_EDUCATION}/${identifier}`, workEducationData);
      return response.data;
    } catch (error) {
      console.error(`Error updating work and education entry ${identifier}:`, error);
      throw error;
    }
  },

  trashWorkEducation: async (identifier) => {
    try {
      const response = await apiClient.delete(`${API_ENDPOINTS.WORK_EDUCATION}/${identifier}`);
      return response.data;
    } catch (error) {
      console.error(`Error trashing work and education entry ${identifier}:`, error);
      throw error;
    }
  },

  restoreWorkEducation: async (identifier) => {
    try {
      const response = await apiClient.post(`${API_ENDPOINTS.WORK_EDUCATION}/${identifier}/restore`);
      return response.data;
    } catch (error) {
      console.error(`Error restoring work and education entry ${identifier}:`, error);
      throw error;
    }
  },

  permanentDeleteWorkEducation: async (identifier) => {
    try {
      const response = await apiClient.delete(`${API_ENDPOINTS.WORK_EDUCATION}/${identifier}/permanent-delete`);
      return response.data;
    } catch (error) {
      console.error(`Error permanently deleting work and education entry ${identifier}:`, error);
      throw error;
    }
  },
};

export default workEducationApi;